//* will have more constants later
// eslint-disable-next-line import/prefer-default-export
export const THEMES = {
  LIGHT: "LIGHT",
  DARK: "DARK",
  NATURE: "NATURE",
};
